import React, { useState } from "react";
import "../Styles/Contact_Form.css";

const WEB3FORMS_KEY = process.env.REACT_APP_WEB3FORMS_KEY;

const Contact_Form = () => {
  const [status, setStatus] = useState(null);
  const [isSending, setIsSending] = useState(false);
  const [formData, setFormData] = useState({
    name: "", email: "", mobile: "", companyname: "", title: "", message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSending) return;
    setIsSending(true);
    setStatus("Sending message...");

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          access_key: WEB3FORMS_KEY,
          subject: formData.title || "New Contact Form Submission",
          from_name: formData.name,
          name: formData.name,
          email: formData.email,
          phone: formData.mobile,
          company: formData.companyname,
          message: formData.message,
        }),
      });
      const data = await res.json();
      if (data.success) {
        setStatus("✅ Thank you! Our experts will contact you shortly.");
        setFormData({ name: "", email: "", mobile: "", companyname: "", title: "", message: "" });
      } else {
        setStatus("❌ Failed to send. Please try again.");
      }
    } catch {
      setStatus("❌ Network error. Please try again.");
    } finally {
      setIsSending(false);
      setTimeout(() => setStatus(null), 5000);
    }
  };

  return (
    <div className="contact-section-container">
      <div className="contact-form-map-grid">
        <div className="contact-form-container">
          <h2>Get in Touch</h2>
          {status && (
            <p className={`status-message ${status.startsWith("❌") ? "error" : status.startsWith("✅") ? "success" : ""}`}>
              {status}
            </p>
          )}
          {(!status || !status.startsWith("✅")) && (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Full Name <span className="required">*</span></label>
                <input type="text" name="name" value={formData.name} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label>Email Address <span className="required">*</span></label>
                <input type="email" name="email" value={formData.email} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label>Phone Number <span className="required">*</span></label>
                <input type="tel" name="mobile" value={formData.mobile} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label>Company Name</label>
                <input type="text" name="companyname" value={formData.companyname} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Subject <span className="required">*</span></label>
                <input type="text" name="title" value={formData.title} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label>Message <span className="required">*</span></label>
                <textarea name="message" rows="5" value={formData.message} onChange={handleChange} required />
              </div>
              <button type="submit" className="submit-button" disabled={isSending}>
                {isSending ? "Sending..." : "Submit to our experts"}
              </button>
            </form>
          )}
        </div>
        <div className="map-container">
          <iframe
            title="Google Map Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d248832.86143181252!2d80.09161448996628!3d12.970990402810484!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a526642fc20dde7%3A0xd654b6e8b7d1efae!2sShanti%20Enterprises%20Electricals%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1765556894367!5m2!1sen!2sin"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contact_Form;
